<template>
    <div class="pmc-right">
        <div>
            <h1>
                Login <span>DecastID</span>
            </h1>
            <p class="mt-8">Two-step verification is enabled for this account!</p>
            <p class="pmc-right-p1 mt-4">Open the two-factor authentication app on your device to view your
                two-factor code and verify your identity</p>
            <form @submit.prevent="handleSubmitCode" class="mt-8">
                <div>
                    <label>Two-factor code</label>
                    <div class="password-div-wrapper">
                        <input id="tfacode" v-model="code" type="number" name="code" placeholder="xxxxxx"
                            autocomplete="off" />
                    </div>
                </div>
                <button class="mt-8" type="submit" :disabled="isVerifying">
                    Verify & Login
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TwoFactorAuthPage',
    data() {
        return {
            code: '',
            isVerifying: false,
        };
    },
    mounted() {
        document.getElementById('loading-bg-transparent').style.display = 'none';
    },
    computed: {
    },
    methods: {
        handleSubmitCode() {
            this.isVerifying = true;
            document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻 Verifying code';
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            const payload = {
                code: this.code,
                token: this.$route.query.tempToken,
            };
            this.$store
                .dispatch('auth/v2loginWith2FA', payload)
                .then((response) => {
                    this.$store.commit('auth/SET_LOGGEDIN', true);
                    this.$acl.change('user');
                    this.$vs.notify({
                        title: 'Login Successful',
                        text: 'Redirecting to dashboard!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success',
                    });
                    this.$router.push('/dashboard/rooms');
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                })
                .catch((error) => {
                    // Safely extract the specific error message
                    const errorResponse = error.response?.data;
                    let message = "An error occurred.";
                    if (errorResponse?.error) {
                        message = errorResponse.error;
                    }
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    this.$vs.notify({
                        title: 'Login Failed',
                        text: message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    });
                }).finally(() => {
                    this.isVerifying = false;
                });
        },
    }
}
</script>

<style scoped>
*:not(i) {
    /* font-family: 'Karla', sans-serif !important; */
    font-family: 'Rethink Sans' !important;
}

button:disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}

#checkbox {
    width: unset !important;
    margin-top: 0px !important;
    margin-right: 10px !important;
    width: 16px !important;
    height: 16px !important;
    cursor: pointer;
}

.pmc-right {
    position: relative;
    overflow: hidden;
    width: 80%;
    height: 100%;
    padding: 70px 70px 0px 70px;
}

.pmc-right p {
    color: #FFFFFF;
}

.pmc-right h1 {
    color: #FFFFFF;
    font-size: 40px;
    line-height: 120%;
}

.pmc-right h1 span {
    color: #D7DF23;
}

.pmc-right .pmc-right-p1 {
    color: #FFFFFF50;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 24px;
    cursor: pointer;
}

.pmc-right label {
    font-size: 14px;
    color: #FFFFFF;
}

.pmc-right input {
    background: #15161F;
    border: 1px solid #444551;
    color: #FFFFFF;
    padding: 0.75rem !important;
    border-radius: 8px !important;
    width: 100% !important;
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
    margin-top: 6px;
    letter-spacing: 8px;
}

.pmc-right button {
    background: #D7DF23;
    border: 1px solid #D7DF23;
    color: #000000;
    padding: 0.75rem;
    border-radius: 12px;
    width: 100%;
    outline: 2px solid transparent;
    outline-offset: 2px;
    cursor: pointer;
    transition: transform 0.05s ease-in-out;
}

.pmc-right button:active {
    transform: scale(0.99);
}

.password-div-wrapper {
    margin-top: 6px;
    position: relative;
}

.password-div-wrapper input {
    margin-top: 6px;
    margin-top: 0px;
}

.password-div-wrapper span {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
}

.check-box-label {
    color: #BCBCBC;
    font-size: 12px;
}

.sep-line {
    background-color: #444551;
    opacity: 0.5;
}

.sep-line-label {
    color: #FFFFFF50;
    background-color: #1B1D29;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

p.text-lime-400 {
    color: #D7DF23;
    display: inline-block;
    margin-top: 12px;
}

@media (max-width: 1024px) {
    .pmc-right {
        width: 100%;
        padding: 70px 40px;
    }
}

@media (max-width: 768px) {}

@media (max-width: 480px) {
    .pmc-right {
        padding: 20px;
    }
}
</style>
